/**
 * HM-387 cluster login PIN: keypad numerico 3x4 + due special key (clear all,
 * backspace). Disabilitato durante submit pending per evitare race con
 * useMutation in flight.
 */
type KeyKind = 'digit' | 'clear' | 'backspace';
type KeyDef = { label: string; kind: KeyKind; value?: string };

const KEYS: KeyDef[] = [
  { label: '1', kind: 'digit', value: '1' },
  { label: '2', kind: 'digit', value: '2' },
  { label: '3', kind: 'digit', value: '3' },
  { label: '4', kind: 'digit', value: '4' },
  { label: '5', kind: 'digit', value: '5' },
  { label: '6', kind: 'digit', value: '6' },
  { label: '7', kind: 'digit', value: '7' },
  { label: '8', kind: 'digit', value: '8' },
  { label: '9', kind: 'digit', value: '9' },
  { label: 'C', kind: 'clear' },
  { label: '0', kind: 'digit', value: '0' },
  { label: '⌫', kind: 'backspace' },
];

export function Keypad({
  onDigit,
  onBackspace,
  onClear,
  disabled,
}: {
  onDigit: (digit: string) => void;
  onBackspace: () => void;
  onClear: () => void;
  disabled?: boolean;
}) {
  return (
    <div className="keypad" data-testid="keypad">
      {KEYS.map((k) => {
        const isSpecial = k.kind !== 'digit';
        const className = `key${isSpecial ? ' special' : ''}`;
        const handler =
          k.kind === 'digit'
            ? () => onDigit(k.value ?? '')
            : k.kind === 'backspace'
              ? onBackspace
              : onClear;
        return (
          <button
            type="button"
            key={k.label}
            className={className}
            onClick={handler}
            disabled={disabled}
            aria-label={
              k.kind === 'digit'
                ? `Cifra ${k.value}`
                : k.kind === 'backspace'
                  ? 'Cancella ultima cifra'
                  : 'Cancella tutto'
            }
            data-testid={`key-${k.kind === 'digit' ? k.value : k.kind}`}
          >
            {k.label}
          </button>
        );
      })}
    </div>
  );
}
